module.exports = __webpack_public_path__ + "img/tags-fill.351959ec.svg";